/** Upload failures can happen while the network is very busy, so the health check may also take longer. */
export const UPLOAD_NETWORK_STATUS_CHECK_TIMEOUT_MS = 10_000;
